/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCrmOpportunityInput
 */
export interface UpdateCrmOpportunityInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateCrmOpportunityInput
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCrmOpportunityInput
     */
    contactName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCrmOpportunityInput
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCrmOpportunityInput
     */
    phone?: string | null;
    /**
     * 
     * @type {UpdateCrmOpportunityInputCrmStatusEnum}
     * @memberof UpdateCrmOpportunityInput
     */
    crmStatus?: UpdateCrmOpportunityInputCrmStatusEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof UpdateCrmOpportunityInput
     */
    nextContactAt?: Date | null;
}


/**
 * @export
 */
export const UpdateCrmOpportunityInputCrmStatusEnum = {
    New: 'new',
    Contacted: 'contacted',
    NeedsHelp: 'needs_help',
    Waiting: 'waiting',
    Active: 'active',
    Churned: 'churned',
    Closed: 'closed'
} as const;
export type UpdateCrmOpportunityInputCrmStatusEnum = typeof UpdateCrmOpportunityInputCrmStatusEnum[keyof typeof UpdateCrmOpportunityInputCrmStatusEnum];


/**
 * Check if a given object implements the UpdateCrmOpportunityInput interface.
 */
export function instanceOfUpdateCrmOpportunityInput(value: object): value is UpdateCrmOpportunityInput {
    return true;
}

export function UpdateCrmOpportunityInputFromJSON(json: any): UpdateCrmOpportunityInput {
    return UpdateCrmOpportunityInputFromJSONTyped(json, false);
}

export function UpdateCrmOpportunityInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCrmOpportunityInput {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'contactName': json['contactName'] === undefined ? undefined : json['contactName'] === null ? null : json['contactName'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
        'crmStatus': json['crmStatus'] === undefined ? undefined : json['crmStatus'] === null ? null : json['crmStatus'],
        'nextContactAt': json['nextContactAt'] === undefined ? undefined : json['nextContactAt'] === null ? null : (new Date(json['nextContactAt'])),
    };
}

export function UpdateCrmOpportunityInputToJSON(json: any): UpdateCrmOpportunityInput {
    return UpdateCrmOpportunityInputToJSONTyped(json, false);
}

export function UpdateCrmOpportunityInputToJSONTyped(value?: UpdateCrmOpportunityInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'contactName': value['contactName'],
        'email': value['email'],
        'phone': value['phone'],
        'crmStatus': value['crmStatus'],
        'nextContactAt': value['nextContactAt'] == null ? value['nextContactAt'] : value['nextContactAt'].toISOString(),
    };
}

